import React from 'react';

// PM‑editable copy separated from UI
export const expenseTrackingTourCopy = {
  headerTitle: 'Expense Tracking',
  headerBody: 'Track and project your expenses across categories with automatic inflation adjustments over 20 years.',
  categoriesTitle: 'Expense Categories',
  categoriesBody: 'View expenses by category - Medical, Kids Education, Home Maintenance, and more. Each category tracks separately.',
  summaryTitle: 'Category Summary',
  summaryBody: 'See total expenses, inflation-adjusted projections, and category breakdowns at a glance.',
  tableTitle: 'Expense Details',
  tableBody: 'Manage individual expenses with custom inflation rates, start/end years, and frequency settings.',
  chartTitle: 'Expense Projection Chart',
  chartBody: 'Visualize how your expenses will change over time with inflation and life events factored in.',
  drawdownTitle: 'Drawdown Priority',
  drawdownBody: 'Set the order in which assets should be liquidated during retirement to fund your expenses.',
};

const Tip = ({ title, body }) => (
  <div>
    <div style={{ fontWeight: 600, color: 'var(--foreground, #111827)' }}>{title}</div>
    <div style={{ marginTop: 6, fontSize: 14, color: 'var(--muted-foreground, #6B7280)' }}>{body}</div>
  </div>
);

export const getExpenseTrackingTourSteps = () => [
  {
    target: '[data-tour="expense-header"]',
    content: <Tip title={expenseTrackingTourCopy.headerTitle} body={expenseTrackingTourCopy.headerBody} />,
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="expense-summary"]',
    content: <Tip title={expenseTrackingTourCopy.summaryTitle} body={expenseTrackingTourCopy.summaryBody} />,
    placement: 'bottom',
  },
  {
    target: '[data-tour="expense-chart"]',
    content: <Tip title={expenseTrackingTourCopy.chartTitle} body={expenseTrackingTourCopy.chartBody} />,
    placement: 'top',
  },
  {
    target: '[data-tour="expense-categories"]',
    content: <Tip title={expenseTrackingTourCopy.categoriesTitle} body={expenseTrackingTourCopy.categoriesBody} />,
    placement: 'bottom',
  },
  {
    target: '[data-tour="expense-table"]',
    content: <Tip title={expenseTrackingTourCopy.tableTitle} body={expenseTrackingTourCopy.tableBody} />,
    placement: 'top',
  },
  {
    target: '[data-tour="expense-drawdown"]',
    content: <Tip title={expenseTrackingTourCopy.drawdownTitle} body={expenseTrackingTourCopy.drawdownBody} />,
    placement: 'top',
  },
];
